<template>
  <div>
    <a-form layout="inline" :model="formState" style="margin-bottom: 10px">
      <a-form-item label="部门">
        <a-input
          v-model:value="formState.name"
          placeholder="输入检索部门"
          allow-clear
        />
      </a-form-item>
      <a-form-item>
        <a-button type="primary" @click="handelSearch">检索</a-button>
      </a-form-item>
      <!--<a-form-item style="position: absolute; right: 30px">-->
      <a-form-item>
        <a-button type="primary" @click="showAddModal" v-if="ableAdd">添加部门</a-button>
      </a-form-item>
    </a-form>
    <a-modal
      v-model:open="open"
      :title="isEdit ? '编辑部门' : '添加部门'"
      :footer="null"
      :destroyOnClose="true"
    >
      <add-dept
        :v-if="open"
        @submit="clickOk"
        :isEdit="isEdit"
        :editData="editData"
        :data="tableData"
      ></add-dept>
    </a-modal>
    <a-tree
      block-node
      :tree-data="showTree"
      :fieldNames="{ title: 'name', key: 'depart_id' }"
      defaultExpandAll
      v-if="ifTree"
    >
      <template #title="{ name, depart_id }">
        <div>
          {{ name }}
          <span class="utils">
            <a-button
              type="primary"
              shape="circle"
              size="small"
              title="添加子部门"
              @click="showAddModal(depart_id, tableData)"
              v-if="ableAdd"
            >
              <PlusOutlined />
            </a-button>
            &nbsp;
            <a-button
              type="primary"
              shape="circle"
              size="small"
              title="编辑部门"
              @click="showEditModal(depart_id, tableData)"
              v-if="ableEdit"
            >
              <EditOutlined />
            </a-button>
            &nbsp;
            <a-popconfirm
              title="确认删除？"
              ok-text="确认"
              cancel-text="取消"
              @confirm="delRow(depart_id)"
              v-if="ableDelete"
            >
              <a-button
                type="primary"
                danger
                shape="circle"
                size="small"
                title="删除部门"
              >
                <DeleteOutlined />
              </a-button>
            </a-popconfirm>
          </span>
        </div>
      </template>
    </a-tree>
  </div>
</template>
<script setup>
  import { ref, reactive, onMounted, computed } from 'vue'
  import { getDeptForManage, deleteDept } from '@/api/system_manage/dept'
  import { useStore } from 'vuex'
  import { buildTree, searchTree } from '@/utils/tree'
  import AddDept from './addDept'
  import { message } from 'ant-design-vue'
  import {
    EditOutlined,
    PlusOutlined,
    DeleteOutlined,
  } from '@ant-design/icons-vue'

  const store = useStore()
  const permissionList = computed(() => store.getters['user/permissionList'])
  const ableAdd = computed(() =>
    !!permissionList.value?.find(item => item.code === 'dept:add')
  )
  const ableEdit = computed(() =>
    !!permissionList.value?.find(item => item.code === 'dept:edit')
  )
  const ableDelete = computed(() =>
    !!permissionList.value?.find(item => item.code === 'dept:delete')
  )

  //1、检索
  const formState = reactive({
    name: '',
  })
  function handelSearch() {
    showTree.value = searchTree('name', formState.name, treeData.value)
  }

  //2、树结构
  const tableData = ref([])
  const treeData = ref([])
  const showTree = ref([])
  const ifTree = computed(() => {
    if (showTree.value?.length > 0) return true
    else return false
  })
  function fetch() {
    getDeptForManage({
      ...formState,
    }).then(({ data }) => {
      tableData.value = data
      const tree = buildTree(data, { idName: 'depart_id' })
      treeData.value = tree
      showTree.value = tree
    })
  }
  onMounted(fetch)

  //3、添加、编辑
  const open = ref(false)
  const isEdit = ref(false)
  const editData = ref(null)
  const showAddModal = (id, data) => {
    editData.value = data ? data.find((item) => item.depart_id === id) : null
    isEdit.value = false
    open.value = true
  }
  const showEditModal = (id, data) => {
    editData.value = data.find((item) => item.depart_id === id)
    isEdit.value = true
    open.value = true
  }
  const handleOk = () => {
    open.value = false
  }
  const clearEditData = () => {
    editData.value = null
  }
  function clickOk() {
    fetch()
    handleOk()
    clearEditData()
  }

  //4、删除
  async function delRow(id) {
    const res = await deleteDept({ departId: id })
    if (res.success) {
      message.success('删除成功！')
      fetch()
    } else {
      message.warn('删除失败' + res.message)
    }
  }
</script>
<style lang="less" scoped>
  .utils {
    display: none;
    .anticon {
      margin: 0 !important;
    }
  }
  .ant-tree-treenode:hover {
    .utils {
      display: inline-block;
    }
  }
</style>
